import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {redirectForDownload} from 'BenchlingUtil';
import ToastMessage from 'nav/toasts/ToastMessage';
import notifications from 'notifications';
import * as StudyDAO from 'studies/StudyDAO';
import AsyncButton, {AsyncButtonLoadingBehavior} from 'ui-library/buttons/AsyncButton';
import {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import * as net from 'util/Net';

export default function StudyDesignExportButton({studyId}: {studyId: string}): JSX.Element | null {
  if (!BenchlingConfig.STUDIES_ENABLE_REVIEW) {
    return null;
  }
  return (
    // Review / export is a work-in-progress
    <Tooltip text="Export study design">
      <AsyncButton
        buttonStyle={ButtonStyle.TERTIARY_WHITE}
        loadingBehavior={AsyncButtonLoadingBehavior.SPINNER}
        size={ButtonSize.SMALL}
        icon="download"
        aria-label="Export study design"
        text={null}
        onClick={async () => {
          const notificationId = `study-design-export:${studyId}`;
          notifications.info('Starting export of study design...', {id: notificationId, duration: 0});
          try {
            const response = await StudyDAO.exportStudyDesign(studyId);
            redirectForDownload(response.url);
            notifications.success('Export of study design was successfully downloaded.', {
              id: notificationId,
            });
          } catch (e) {
            if (net.isServerRequestError(e)) {
              notifications.error(
                <ToastMessage
                  header="Failed to export study design"
                  body={notifications.getFriendlyErrorAsElement(e, '')}
                />,
                {id: notificationId}
              );
            } else {
              notifications.close(notificationId);
              throw e;
            }
          }
        }}
      />
    </Tooltip>
  );
}
